const { registerBlockType } = wp.blocks;
const { createElement,RawHTML }  = wp.element;
const { select,withSelect  } = wp.data;
const { components,SelectControl } = wp.components;
const {__} = wp.i18n; //translation functions

registerBlockType('ede/ede-custom-block', {
	title: __('Easy Embedder Plugin','easy-document-embedder'),
	description: __('Select Document to display frontend','easy-document-embedder'),
	category: 'layout',
	icon: 'media-text',

	attributes:{
		id : {
			default: 1,
        },
        heading: {
			default: 'h2'
		}
	},
	
	edit: withSelect( ( select ) => {
		var query = { 
			per_page : 10,
			orderby : 'date',
			order : 'asc',
			status : 'publish',
		}

		return {
			posts: select( 'core' ).getEntityRecords( 'postType', 'ede_embedder', query ),
		}
	} )( props => {
		const { posts } = props;
		const attributes =  props.attributes;
        const setAttributes =  props.setAttributes;
		
		var options = [];

		if (!posts) {
			return (
				<p>{ __( 'Loading...', 'easy-document-embedder' ) }</p>
			);
		}else {
			options.push( { value: 0, label: 'Select Document' } );
			posts.forEach((post) => { // simple foreach loop
				options.push({value:post.id, label:post.title.raw});
			});
		}
		function changeID(id){
			setAttributes({id});
		}
		
		return createElement('div', {}, [
			//preview will go here
			createElement(SelectControl, {
				label: __('Select Document','easy-document-embedder'),
				options : options,
				onChange: changeID,
				value: attributes.id,
			}),
			
		] )

		
	} ),
	save: props => {
		const ede_id = props.attributes.id
		return "[EDE id=".concat(ede_id,"]")
	}
	
});